import { styled } from "styled-components";

export const StickyStyle = styled.div`
  top: 0;
  position: sticky;
  background-color: #fff;
  max-width: 834px;
  z-index: 1;
`;
